import api from '../../../utils/api'

export const getBlogsApi = (data) => api.get('/admin/blogs', { params: data })
export const createArticleApi = (data) => api.post('/admin/blogs', data)
export const updateArticleApi = (id, data) => api.put(`/admin/blogs/${id}`, data)
export const deleteArticleApi = (id) => api.delete(`/admin/blogs/${id}`)
